import * as yup from 'yup';
import { useTranslations } from 'hooks/useTranslations';
import { countEditorCharacters } from 'components/organisms/HtmlSlate';

const useFRTFormSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    makeUniqueId: yup
      .string()
      .required(t('formAutocomplete.validation.text'))
      .max(64, t('general.field.validation.maxCharacters').replace('{0}', '64'))
      .trim(),
    modelUniqueId: yup
      .string()
      .required(t('formAutocomplete.validation.text'))
      .max(64, t('general.field.validation.maxCharacters').replace('{0}', '64'))
      .trim(),
    manufacturerUniqueId: yup
      .string()
      .required(t('formAutocomplete.validation.text'))
      .max(64, t('general.field.validation.maxCharacters').replace('{0}', '64'))
      .trim(),
    actionUniqueId: yup.string().required(t('general.field.validation.required')).trim(),
    typeUniqueId: yup.string().required(t('general.field.validation.required')).trim(),
    countryUniqueId: yup.string().required(t('general.field.validation.required')).trim(),
    ACT: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    AKA: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    BAR: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    CAL: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    IMG: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    IMP: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    LAW: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    MAK: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    MAN: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    MDT: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    MOD: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    MRK: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    REM: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    SER: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    SHT: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    TYP: yup
      .string()
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '4000'),
        (value) => countEditorCharacters(value) <= 4000,
      )
      .trim(),
    productCodes: yup.array().of(
      yup.object().shape({
        productCode: yup
          .string()
          .max(66, t('general.field.validation.maxCharacters').replace('{0}', '66')),
      }),
    ),
  });

  return { schema };
};

export default useFRTFormSchema;
